import {IPaginatedResult} from '../incase-domain/search';

export const getNextPage = <T>(lastPage: IPaginatedResult<T> | undefined): number | undefined => {
    if (!lastPage) return undefined;
    if (lastPage.pageNumber * lastPage.pageSize < lastPage.numberOfElements) {
        return lastPage.pageNumber + 1;
    }
    return undefined;
};
